import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { Shimmer } from '@paypalcorp/pp-react-utils';
import clsx from 'clsx';
import '../__generated__/styles/tile.css';

var styles = {"ppvx_tile":"ppvx_tile___2-8-7","ppvx_tile--card":"ppvx_tile--card___2-8-7","ppvx_tile--corner-radius_lg":"ppvx_tile--corner-radius_lg___2-8-7","ppvx_tile--divider":"ppvx_tile--divider___2-8-7","ppvx_tile__header":"ppvx_tile__header___2-8-7","ppvx_tile__header-title":"ppvx_tile__header-title___2-8-7","ppvx_tile__content":"ppvx_tile__content___2-8-7","ppvx_tile__content-text":"ppvx_tile__content-text___2-8-7","ppvx_tile__footer":"ppvx_tile__footer___2-8-7","ppvx--v2":"ppvx--v2___2-8-7","ppvx--v1":"ppvx--v1___2-8-7"};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Tile = function (_ref) {
  var _clsx;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      card = _ref.card,
      children = _ref.children,
      className = _ref.className,
      divider = _ref.divider,
      cardRadius = _ref.cardRadius,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      isInverse = _ref.isInverse,
      rest = _objectWithoutProperties(_ref, ["as", "card", "children", "className", "divider", "cardRadius", "theme", "isLoading", "isInverse"]);

  var _theme = useTheme('Tile', theme);

  var isThemeV2 = _theme && _theme === 'v2';

  if (isThemeV2 && isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, {
      isInverse: isInverse
    }, children);
  }

  var tileClasses = clsx(styles.ppvx_tile, (_clsx = {}, _defineProperty(_clsx, styles['ppvx_tile--divider'], divider), _defineProperty(_clsx, styles['ppvx_tile--card'], card || isThemeV2), _defineProperty(_clsx, styles["ppvx_tile--corner-radius_".concat(cardRadius)], card && cardRadius === 'lg'), _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _clsx), className);
  return React.createElement(as, _objectSpread({
    className: tileClasses
  }, rest), children);
};

var Header = function (_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["className", "children"]);

  var headerClasses = clsx(styles.ppvx_tile__header, className);
  return /*#__PURE__*/React.createElement("header", _extends({
    className: headerClasses
  }, rest), /*#__PURE__*/React.createElement("h3", {
    className: styles['ppvx_tile__header-title']
  }, children));
};

var Content = function (_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["className", "children"]);

  var contentClasses = clsx(styles.ppvx_tile__content, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: contentClasses
  }, rest), children);
};

var Footer = function (_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["className", "children"]);

  var footerClasses = clsx(styles.ppvx_tile__footer, className);
  return /*#__PURE__*/React.createElement("footer", _extends({
    className: footerClasses
  }, rest), children);
};

Tile.Header = Header;
Tile.Content = Content;
Tile.Footer = Footer;

export { Tile };
